import React from 'react';
import { Icon, Tooltip } from '@nimbus-ds/components';
import { InfoCircleIcon } from '@nimbus-ds/icons';
import { SettledAmountDto } from '@tiendanube/common';

interface ExchangeRateTooltipProps {
  readonly settledAmount: SettledAmountDto;
  readonly position: 'top' | 'bottom' | 'left' | 'right';
}

function ExchangeRateTooltip({
  settledAmount,
  position,
}: ExchangeRateTooltipProps): React.JSX.Element {
  const { exchange_rate, currency } = settledAmount;
  const tooltipContent = `${exchange_rate.from} 1 = ${currency} ${exchange_rate.value}`;

  return (
    <Tooltip content={tooltipContent} position={position} arrow>
      <Icon
        source={<InfoCircleIcon size="small" />}
        color="neutral-textLow"
        onClick={(e) => e.stopPropagation()}
      />
    </Tooltip>
  );
}

export default ExchangeRateTooltip;
